import * as types from '../types';

const initialState = {
    progress: null,
    loading: false,
    error: null,
};

export const scorm = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_SCORM_PROGRESS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case types.GET_SCORM_PROGRESS_SUCCESS:
            return {
                ...state,
                loading: false,
                progress: action.payload,
                error: null,
            };
        case types.GET_SCORM_PROGRESS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};
